import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M16.5 0h-12C3.675 0 3 .675 3 1.5v4.239A12.79 12.79 0 0 1 5.5 5.5c.17 0 .334.007.5.013V4h2v1.739c2.708.539 4.5 1.955 4.5 3.761 0 .54-.165 1.042-.461 1.5H16.5c.825 0 1.5-.675 1.5-1.5v-8c0-.825-.675-1.5-1.5-1.5zm-11 13.5c-2.261 0-4.175-.524-5.427-1.388A1.185 1.185 0 0 0 0 12.5C0 13.881 2.462 15 5.5 15s5.5-1.119 5.5-2.5c0-.132-.029-.261-.073-.388C9.675 12.976 7.761 13.5 5.5 13.5zm0 3c-2.261 0-4.175-.524-5.427-1.388A1.185 1.185 0 0 0 0 15.5C0 16.881 2.462 18 5.5 18s5.5-1.119 5.5-2.5c0-.132-.029-.261-.073-.388C9.675 15.976 7.761 16.5 5.5 16.5zm0-9.5C2.462 7 0 8.119 0 9.5S2.462 12 5.5 12 11 10.881 11 9.5 8.538 7 5.5 7z" />
  </svg>
);

export default SvgComponent;
